import React from 'react'
import styled from 'styled-components'
import { Button } from 'pcln-design-system'

const StyledButton = styled(Button)`
  height: 56px;
`

type SearchFormButtonProps = {
  buttonText: string
  handleClick?: () => void
  [key: string]: unknown
}
export default function SearchFormButton({
  buttonText,
  handleClick = () => {
    // empty default function
  },
  ...buttonProps
}: SearchFormButtonProps) {
  return (
    <StyledButton
      width={1}
      px={1}
      py={0}
      size="large"
      onClick={handleClick}
      type="submit"
      {...buttonProps}
    >
      {buttonText}
    </StyledButton>
  )
}
